/*
*###############################################################################
*Module Name                   : DPTextBox.js                                  #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  T A C Priyashad                              #
*Date                          : Tuesday, August 24th 2021, 1:47:16 pm         #
*Copyright (c) 2021 myPOS Software Solution (pvt Ltd.)                         #
*###############################################################################
*/

// import React, { useState } from 'react';
// import { Row, Label, Input } from "reactstrap"


// const DPTextBox = ({ rowClass, labelText, textType, value, onChange, placeholder, textAlign, disabled, onKeyPress, onBlur, id, colWidth, step, min, max, pattern, hidden }) => {
//     const colSize = colWidth ? colWidth : 3
//     return (
//         <Row className={rowClass} hidden={hidden}>
//             <Label
//                 htmlFor="example-text-input"
//                 className={`col-md-${colSize} col-form-label-sm`}
//             >
//                 {labelText}
//             </Label>
//             <div className={`col-md-${12 - colSize}`}>
//                 <Input
//                     className="form-control-sm"
//                     type={textType}
//                     value={value}
//                     step={step}
//                     min={min}
//                     max={max}
//                     pattern={pattern}
//                     onChange={onChange}
//                     onKeyPress={onKeyPress}
//                     onBlur={onBlur}
//                     onFocus={(e) => {
//                         e.target.select()
//                     }}
//                     placeholder={placeholder}
//                     style={{ textAlign: textAlign ? textAlign : 'left' }}
//                     disabled={disabled}
//                     id={id}
//                 />
//             </div>
//         </Row>
//     );
// }

// export default DPTextBox;

import React, { useEffect, useState } from 'react';
import { Row, Label, Input, Button } from 'reactstrap';

const DPTextBox = ({
    rowClass,
    labelText,
    textType,
    value,
    onChange,
    placeholder,
    textAlign,
    disabled,
    onKeyPress,
    onBlur,
    id,
    colWidth,
    step,
    min,
    max,
    pattern,
    hidden,
    showHiddenPassword,
    name
}) => {
    const colSize = colWidth ? colWidth : 3;
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);

    const togglePasswordVisibility = () => {
        setIsPasswordVisible((prev) => !prev);
    };

    useEffect(() => {
        setIsPasswordVisible(false);
    },[disabled])

    if (showHiddenPassword) {
        return (
            <Row className={rowClass} hidden={hidden}>
                <Label htmlFor="example-text-input" className={`col-md-${colSize} col-form-label-sm`}>
                    {labelText}
                </Label>
                <div className={`col-md-${12 - colSize} d-flex align-items-center mb-0`}>
                    <Input
                        className="form-control-sm"
                        type={isPasswordVisible ? 'text' : 'password'}
                        value={value}
                        step={step}
                        min={min}
                        max={max}
                        pattern={pattern}
                        onChange={onChange}
                        onKeyPress={onKeyPress}
                        autoComplete='off'
                        onBlur={onBlur}
                        onFocus={(e) => {
                            e.target.select();
                        }}
                        placeholder={placeholder}
                        style={{ textAlign: textAlign ? textAlign : 'left' }}
                        disabled={disabled}
                        id={id}
                        name={name}
                    />
                    <Button size="sm" onClick={togglePasswordVisibility} disabled={disabled}>
                        <i className={`mdi ${isPasswordVisible ? 'mdi-eye-off' : 'mdi-eye'}`} style={{ fontSize: "12px" }}></i>
                    </Button>
                </div>

            </Row>
        );
    } else {
        return (
            <Row className={rowClass} hidden={hidden}>
                <Label htmlFor="example-text-input" className={`col-md-${colSize} col-form-label-sm`}>
                    {labelText}
                </Label>
                <div className={`col-md-${12 - colSize} mb-0`}>
                    <Input
                        className="form-control-sm"
                        type={textType}
                        value={value}
                        step={step}
                        min={min}
                        max={max}
                        pattern={pattern}
                        onChange={onChange}
                        onKeyPress={onKeyPress}
                        onBlur={onBlur}
                        onFocus={(e) => {
                            e.target.select();
                        }}
                        placeholder={placeholder}
                        style={{ textAlign: textAlign ? textAlign : 'left' }}
                        disabled={disabled}
                        id={id}
                        name={name}
                        title={placeholder}
                    />
                </div>
            </Row>
        );
    }

};

export default DPTextBox;
